

import React, { useEffect, useState } from "react";
import styles from "./contact_us.module.css";
import ContactFooter from "./footer";

import ContactHero from "./contact_hero";
import ContactForm from "./conact_form";
import { useTranslation } from "react-i18next";

function ContactUs() {
  const { t, i18n } = useTranslation();

  const [lang, setLang] = useState(
    localStorage.getItem("lang") || "ar"
  );

  useEffect(() => {
    i18n.changeLanguage(lang);
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang, i18n]);

  return (
    <div>
      <div >
        <div className={styles.overlay}>
          <div className={styles.TopframeCont}>
            <div className={styles.topFrame}></div>
          </div>
          <div
            style={{
              height: "100% ",
              overflowY: "auto",
              display: "flex",
              flexDirection: `column`,
              width: `100%`,
            }}
          >
            <div className={styles.subScroll}>
              <div className={styles.subScroll_child} >
                <ContactHero  t={t}/>
                <ContactForm t={t} i18n={i18n} />
              </div>

              {/* <ContactFooter/> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
